import * as React from 'react';

export const coFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_476)'>
            <mask
                id='mask0_1_476'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_476)'>
                <path
                    d='M25.3333 0H2.66667C1.19391 0 0 1.19391 0 2.66667V17.3333C0 18.8061 1.19391 20 2.66667 20H25.3333C26.8061 20 28 18.8061 28 17.3333V2.66667C28 1.19391 26.8061 0 25.3333 0Z'
                    fill='#002C88'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 14.6667H28V20H0V14.6667Z'
                    fill='#C9072A'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 0H28V9.33333H0V0Z'
                    fill='#FFCE00'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_476'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
